import {
  APP_LOADING_BEGIN,
  APP_LOADING_END,
  TOGGLE_COLLAPSED,
  CHANGE_HEADER_TITLE,
  UPDATE_LINK_LGPD,
  UPDATE_LINK_POLICY,
} from '../actiontypes/app';

const INITIAL_STATE = {
  loading: false,
  collapsed: false,
  headerTitle: '',
  policyAndCookiesUrl: '',
  lgpdUrl: '',
};

const app = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APP_LOADING_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case APP_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    case TOGGLE_COLLAPSED:
      return {
        ...state,
        collapsed: !state.collapsed,
      };
    case CHANGE_HEADER_TITLE:
      return {
        ...state,
        headerTitle: action.headerTitle,
      };
    case UPDATE_LINK_LGPD:
      return {
        ...state,
        lgpdUrl: action.link,
      };
    case UPDATE_LINK_POLICY:
      return {
        ...state,
        policyAndCookiesUrl: action.link,
      };
    default:
      return state;
  }
};

export default app;
